import { createFileRoute } from "@tanstack/react-router";
import PurchaseOrderForm from "@/features/inventory/PurchaseOrderForm";

export const Route = createFileRoute("/inventory/orders/new")({
  component: () => (
    <div className="max-w-4xl mx-auto p-4">
      <PurchaseOrderForm />
    </div>
  ),
});
